export default __webpack_public_path__ + "static/Nexus_Reminder_Banner-2d526638e7e257eacc4801e1f8eef5be.png";